module.exports = __webpack_public_path__ + "static/img/1.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/1.jpg
// module id = yZ2I
// module chunks = 36